import { istToday, rangeForPreset } from "../AgentAnalytics/fleetRange";

export const PRESETS = [
  { key: "7d", label: "7d" },
  { key: "30d", label: "30d" },
  { key: "custom", label: "Custom" },
];

export const isValidRange = (from, to) =>
  Boolean(from) && Boolean(to) && from <= to;

export const defaultCustom = (today = istToday()) =>
  rangeForPreset("7d", null, today);

export const resolveRange = (preset, custom = {}, today = istToday()) => {
  if (preset !== "custom") return rangeForPreset(preset, null, today);
  if (isValidRange(custom.from, custom.to)) {
    return { from: custom.from, to: custom.to };
  }
  return rangeForPreset("7d", null, today);
};

export const rangeLabel = ({ from, to } = {}) => {
  if (!from || !to) return "";
  return from === to ? from : `${from} → ${to}`;
};
